import React from "react";
import { IconType } from "react-icons";
import { MdCheckCircle } from "react-icons/md";
import { useTheme } from "../../../../hooks/useTheme";
import styles from "./SelectableCard.module.scss";

interface SelectableCardProps {
  isSelected: boolean;
  onSelect: () => void;
  icon?: IconType;
  label: string;
  className?: string;
  showCheckmark?: boolean;
  small?: boolean;
}

export default function SelectableCard({
  isSelected,
  onSelect,
  icon: Icon,
  label,
  className = "",
  showCheckmark = true,
  small = false,
}: SelectableCardProps) {
  const { theme } = useTheme();

  return (
    <button
      className={`${styles.card} ${small ? styles.small : ""} ${className}`}
      onClick={onSelect}
      style={{
        backgroundColor: isSelected ? theme.primary : "transparent",
        borderColor: isSelected ? theme.primary : theme.border,
      }}
    >
      {Icon && (
        <div className={styles.iconContainer}>
          <Icon
            size={32}
            color={isSelected ? theme.onPrimary : theme.primary}
          />
        </div>
      )}

      <span
        className={`${styles.label} ${small ? styles.smallLabel : ""}`}
        style={{ color: isSelected ? theme.onPrimary : theme.text }}
      >
        {label}
      </span>

      {isSelected && showCheckmark && (
        <div className={styles.checkmark}>
          <MdCheckCircle size={20} color={theme.onPrimary} />
        </div>
      )}
    </button>
  );
}
